import { format, isSameMinute as isSameMinute$1, isSameDay as isSameDay$1, isBefore as isBefore$1, isWithinInterval, eachDayOfInterval, addYears, addMonths, addWeeks, addDays, addHours, parseISO, isValid } from "date-fns";
const dateToDayAndNumberString = (date) => format(date, "EEEE d");
const dateToDayNumberMonthYearString = (date) => format(date, "EEEE d MMMM, yyyy");
const dateToLocalTime = (date, timeFormat = "24h") => timeFormat === "amPm" ? format(date, "h:mma") : format(date, "H:mm");
const datesToLocalTimeSpan = (from, until, timeFormat = "24h") => `${dateToLocalTime(from, timeFormat)} - ${dateToLocalTime(until, timeFormat)}`;
const dateToShortTime = (date) => dateToLocalTime(date);
const isSameMinute = (date1, date2) => isSameMinute$1(date1, date2);
const isSameDay = (date1, date2) => isSameDay$1(date1, date2);
const isBefore = (date1, date2) => isBefore$1(date1, date2);
const isDateBefore = (date1, date2) => new Date(date1).setHours(0, 0, 0, 0) < new Date(date2).setHours(0, 0, 0, 0);
const sortDesc = (left, right) => right.getTime() - left.getTime();
const isWithinTimeSpan = (date, start, end) => isWithinInterval(date, { start, end });
const toLocalDateTime = (date) => format(date, "yyyy-MM-dd'T'HH:mm:ss");
const toLocalDateTimeTimeZone = (date) => format(date, "yyyy-MM-dd'T'HH:mm:ss:xxx");
const toLocalDate = (date) => format(date, "yyyy-MM-dd");
const eachDay = (start, end) => eachDayOfInterval({ start, end });
const shiftDate = (date, period, amount = 1) => {
  switch (period) {
    case "hour":
      return addHours(date, amount);
    case "day":
      return addDays(date, amount);
    case "week":
      return addWeeks(date, amount);
    case "month":
      return addMonths(date, amount);
    case "year":
      return addYears(date, amount);
  }
};
const getDateListFromDate = (date, size = 7) => eachDay(date, shiftDate(date, "day", size - 1));
const pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
const parseLocalDateTime = (input) => {
  if (!pattern.test(input)) {
    throw new Error(`Invalid local datetime string: ${input}`);
  }
  return parseISO(input);
};
const minutesToHM = (value, locale) => {
  const baseSettings = {
    style: "unit",
    notation: "compact",
    compactDisplay: "short"
  };
  if (value === 0) {
    return Intl.NumberFormat(locale, { ...baseSettings, unit: "minute" }).format(value);
  }
  const hours = Math.floor(value / 60);
  const minutes = Math.floor(value % 60);
  const hDisplay = hours > 0 ? Intl.NumberFormat(locale, { ...baseSettings, unit: "hour" }).format(hours) : "";
  const mDisplay = minutes > 0 ? Intl.NumberFormat(locale, { ...baseSettings, unit: "minute" }).format(minutes) : "";
  return `${hDisplay} ${mDisplay}`.trim();
};
const isValidDateRange = (startDate, endDate) => {
  if (!isValid(startDate) || !isValid(endDate)) {
    return false;
  }
  return !isBefore(endDate, startDate);
};
export {
  dateToDayAndNumberString,
  dateToDayNumberMonthYearString,
  dateToLocalTime,
  dateToShortTime,
  datesToLocalTimeSpan,
  eachDay,
  getDateListFromDate,
  isBefore,
  isDateBefore,
  isSameDay,
  isSameMinute,
  isValidDateRange,
  isWithinTimeSpan,
  minutesToHM,
  parseLocalDateTime,
  shiftDate,
  sortDesc,
  toLocalDate,
  toLocalDateTime,
  toLocalDateTimeTimeZone
};
//# sourceMappingURL=date-utils.js.map
